/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { socialGetSocialQqUserinfo } from "../../funcs/socialGetSocialQqUserinfo.js";
import { GetSocialQqUserinfoRequest$zodSchema } from "../../models/getsocialqquserinfoop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetSocialQqUserinfoRequest$zodSchema,
};

export const tool$socialGetSocialQqUserinfo: ToolDefinition<typeof args> = {
  name: "social-get-social-qq-userinfo",
  description: `查询 QQ 信息

这是一个功能丰富的QQ用户信息查询接口，能够获取QQ用户的详细公开信息。

> [!VIP]
> 我们在近日优化了此接口，速度应该会更加快了。 

## 功能概述
通过QQ号查询用户的详细信息，包括基础资料、等级信息、VIP状态等。返回的信息丰富全面，适合用于用户画像分析、社交应用集成等场景。

## 数据字段说明
- **基础信息**: 昵称、个性签名、头像、年龄、性别
- **联系信息**: QQ邮箱、个性域名(QID)
- **等级信息**: QQ等级、VIP状态和等级
- **时间信息**: 注册时间、最后更新时间`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await socialGetSocialQqUserinfo(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
